import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, requireUsername = true }) {
  const { user, profile, loading } = useAuth();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen t-bg-page flex items-center justify-center">
        <div role="status" aria-label={t('common.loading')}>
          <div className="w-8 h-8 border-2 border-(--c-focus) border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (requireUsername && !profile) return <Navigate to="/setup" replace />;

  return children;
}
